import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import ImpersonateLogin from "./pages/ImpersonateLogin";
import Dashboard from "./pages/Dashboard";
import History from "./pages/History";
import Buyers from "./pages/Buyers";
import Design from "./pages/Design";
import Faqs from "./pages/Faqs";
import NotFound from "./pages/NotFound";
import ProtectedRoute from "./components/ProtectedRoute";
import MainLayout from "./components/MainLayout";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/impersonate" element={<ImpersonateLogin />} />

      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <MainLayout>
              <Routes>
                <Route path="/" element={<Navigate to="/dashboard" />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/history" element={<History />} />
                <Route path="/buyers" element={<Buyers />} />
                <Route path="/design" element={<Design />} />
                <Route path="/faqs" element={<Faqs />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </MainLayout>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
};

export default AppRoutes;
